import {SingleSelectGridPickerDialog} from '@dms/shared';

// BE single-select branch picker datagrid; row id = branch id.
const BRANCH_PICKER_GRID_CODE = 'record-audit-pair-branch';

interface RecordAuditBranchPickerDialogProps {
  onConfirm: (branchId: string) => void;
}

/**
 * Single-select branch picker backed by the BE `record-audit-pair-branch` datagrid (row id =
 * branch id), replacing the former inline branch-switch dropdown.
 */
export function RecordAuditBranchPickerDialog(props: RecordAuditBranchPickerDialogProps) {
  return (
    <SingleSelectGridPickerDialog
      gridCode={BRANCH_PICKER_GRID_CODE}
      onConfirm={props.onConfirm}
      data-testid="recordAuditBranchPicker"
    />
  );
}
